import { ExtraInfo, MetricsConstructor } from '../core/metrics';

const name = '';

const { logger, monitor } = new MetricsConstructor(
  name,
  (extra: ExtraInfo) => ({
    ...extra,
  }),
);

export { logger, monitor };
